import { render, staticRenderFns } from "./ButtonWithArrowIcon.vue?vue&type=template&id=1910e788&scoped=true"
import script from "./ButtonWithArrowIcon.vue?vue&type=script&lang=js"
export * from "./ButtonWithArrowIcon.vue?vue&type=script&lang=js"
import style0 from "./ButtonWithArrowIcon.vue?vue&type=style&index=0&id=1910e788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1910e788",
  null
  
)

export default component.exports